/**
 * Public-facing top navigation bar (for landing, login, register).
 */

import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Code2, Menu, X } from 'lucide-react';

export default function Navbar() {
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <>
      <nav className="navbar">
        <div className="container">
          <Link to="/" className="nav-brand" onClick={() => setMobileOpen(false)}>
            <Code2 size={28} />
            <span>token-kit</span>
          </Link>

          <div className="nav-links">
            <a href="/#how-it-works">How It Works</a>
            <a href="/#features">Features</a>
            <a href="/#pricing">Pricing</a>
            <Link to="/sdk">SDK Docs</Link>
          </div>

          <div className="nav-actions">
            <Link to="/login" className="btn btn-accent btn-sm">Sign In</Link>
          </div>

          <button className="nav-hamburger" onClick={() => setMobileOpen(!mobileOpen)}>
            {mobileOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </nav>

      <div className={`mobile-nav${mobileOpen ? ' open' : ''}`}>
        <a href="/#how-it-works" onClick={() => setMobileOpen(false)}>How It Works</a>
        <a href="/#features" onClick={() => setMobileOpen(false)}>Features</a>
        <a href="/#pricing" onClick={() => setMobileOpen(false)}>Pricing</a>
        <Link to="/sdk" onClick={() => setMobileOpen(false)}>SDK Docs</Link>
        <Link to="/login" onClick={() => setMobileOpen(false)}>Sign In</Link>
        <Link to="/sdk" className="btn btn-accent" onClick={() => setMobileOpen(false)}>SDK Docs</Link>
      </div>
    </>
  );
}
